<app-header [pageTitle]="'404'" [back]="'native'"></app-header>

<ion-content>
  <ion-grid [fixed]="true" class="cont">
    <ion-row>
      <ion-col>
        <div class="container not-found">
          <div class="title-not-found">404</div>
          <h2 class="title-h2">
            Такой страницы не существует.
          </h2>
          <p>
            Возможно ошибка в запрашиваемом вами адресе.
            Вы можете вернуться на предыдущую страницу или перейти на Главную и воспользоваться меню сайта.
          </p>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
